import type { ReactNode } from "react";
import { LuRefreshCcw } from "react-icons/lu";

import { cn } from "@/utils/lib";

import { Button } from "../ui/button";

export const PopoverFilterSortActions = ({
  onSubmitClick,
  onResetClick,
  customSubmitButton,
  className,
  submitLabel = "Apply",
}: {
  onSubmitClick?: () => void;
  onResetClick?: () => void;
  customSubmitButton?: ReactNode;
  className?: string;
  submitLabel?: string;
}) => {
  return (
    <div
      className={cn(
        `
          sticky bottom-0 z-10 flex w-auto items-center gap-4 rounded-none
          border border-x-0 border-b-0 border-border bg-card/95 p-4
          backdrop-blur-sm
        `,
        className,
      )}
    >
      {customSubmitButton || (
        <Button variant="success" size="lg" onClick={() => onSubmitClick?.()}>
          {submitLabel}
        </Button>
      )}

      {onResetClick && (
        <Button
          size="sm"
          variant="link"
          onClick={onResetClick}
          className="ml-auto flex h-auto items-center gap-2 p-0 text-muted"
        >
          <LuRefreshCcw />
          Reset
        </Button>
      )}
    </div>
  );
};
